import { ICONS } from "./icons";
import { BETTING_TASKS_MODULES, FREE_TO_PLAY_MODULE_NAMES, JACKPOT_MODULE_NAMES, VOUCHER_CATEGORIES, VOUCHER_MODULE_NAMES } from "./enums";
import { ROUTES } from "./routes";

export const TASK_BAR_MENU_ITEMS = [
    {
        className: "task-bar-button",
        hasSelection: true,
        buttonName: ROUTES.HOME,
        routerLink: ROUTES.BETTING_TASKS,
        content: "Početna",
        imgSrc: ICONS.HOME,
        selectedImgSrc: ICONS.HOME_SELECTED
    },
    {
        className: "task-bar-button",
        hasSelection: true,
        buttonName: ROUTES.МАX_VOUCHERS,
        routerLink: ROUTES.МАX_VOUCHERS,
        content: "Prodavnica",
        imgSrc: ICONS.MARKETPLACE,
        selectedImgSrc: ICONS.MARKETPLACE_SELECTED
    },
    {
        className: "task-bar-button scanner__btn",
        hasSelection: true,
        buttonName: ROUTES.QR_SCANNER,
        routerLink: ROUTES.QR_SCANNER,
        content: "Skeniraj",
        imgSrc: ICONS.SCAN,
        selectedImgSrc: ICONS.SCAN_SELECTED,
    },
    {
        className: "task-bar-button",
        hasSelection: true,
        buttonName: ROUTES.BAR_CODE,
        routerLink: ROUTES.BAR_CODE,
        content: "Kartica",
        imgSrc: ICONS.CARD,
        selectedImgSrc: ICONS.CARD_SELECTED,
    },
    {
        className: "task-bar-button",
        hasSelection: true,
        buttonName: ROUTES.PROFILE,
        routerLink: ROUTES.PROFILE,
        content: "Profil",
        imgSrc: ICONS.PROFILE,
        selectedImgSrc: ICONS.PROFILE_SELECTED,
    }
];

export const NAV_BAR_MENU_ITEMS = [
    {
        className: "max-cafe",
        routeName: ROUTES.HOME_CAFE,
        content: "MaxCafé"
    },
    {
        className: "betting",
        routeName: ROUTES.BETTING_TASKS,
        content: "Klađenje"
    }
];

export const VOUCHER_TAB_MENU_ITEMS = [
    {
        content: "Shop",
        moduleName: VOUCHER_MODULE_NAMES.VOUCHERS
    },
    {
        content: "Moji Vaučeri",
        moduleName: VOUCHER_MODULE_NAMES.MY_VOUCHERS
    }
];

export const FREE_TO_PLAY_TAB_MENU_ITEMS = [
    {
        content: "AKTIVNI",
        moduleName: FREE_TO_PLAY_MODULE_NAMES.ACTIVE_TICKETS
    },
    {
        content: "ISTORIJA",
        moduleName: FREE_TO_PLAY_MODULE_NAMES.SUBMITTED_TICKETS
    }
];

export const BETTING_TASKS_TAB_MENU_ITEMS = [
    {
        content: "U toku",
        moduleName: BETTING_TASKS_MODULES.IN_PROGRESS
    },
    {
        content: "Završeni",
        moduleName: BETTING_TASKS_MODULES.FINISHED
    }
];

export const JACKPOT_MENU_ITEMS = [
    {
        content: "Lokalni",
        moduleName: JACKPOT_MODULE_NAMES.LOCAL
    },
    {
        content: "Globalni",
        moduleName: JACKPOT_MODULE_NAMES.GLOBAL
    }
];

export const VOUCHER_TAB_FILTER_MENU_ITEMS = [
    {
        content: "SVI",
        category: VOUCHER_CATEGORIES.ALL
    },
    {
        content: "BETTING",
        category: VOUCHER_CATEGORIES.BETTING
    }
];

export const BETTING_TAB_MENU_ITEMS = [
    {
        content: "Zadaci",
        routeName: ROUTES.BETTING_TASKS
    },
    // {
    //     content: "Free To Play",
    //     routeName: ROUTES.FREE_TO_PLAY,
    // },
    {
        content: "Jackpot",
        routeName: ROUTES.BETTING_JACKPOT,
    },
];

export const HISTORY_TAB_MENU_ITEMS = [
    {
        className: "max-cafe",
        content: "MaxCafé",
    },
    {
        className: "betting",
        content: "Klađenje"
    },
    {
        className: "mbc-expired",
        content: "Istekli MBC"
    }
];